var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 350,
    viewBox: "0 0 500 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.329 205.913C183.305 203.94 173.039 190.4 173.039 190.4C173.039 190.4 173.4 183.976 174.113 182.211C174.827 180.446 177.314 178.602 178.878 177.856C180.442 177.11 183.995 177.142 183.995 177.142C183.995 177.142 183.634 189.662 183.843 190.866C184.051 192.069 185.327 192.349 185.327 192.349H182.102C186.169 198.67 194.342 205.913 194.342 205.913L195.93 206.53C195.93 206.53 196.444 213.236 195.473 215.281C194.503 217.326 187.308 220.07 187.027 220.302C186.746 220.535 186.209 219.997 186.209 219.997L185.8 210.629L183.329 205.913ZM183.329 205.913C180.281 208.295 176.792 212.009 176.792 212.009C166.895 232.285 170.031 271.532 170.031 271.532H175.148C175.148 271.532 174.057 276.071 174.057 276.039C174.057 276.007 169.004 276.039 169.004 276.039C169.004 276.039 165.868 282.729 166.004 301.49C166.141 320.25 176.111 342.115 176.111 342.115H215.838C215.838 342.115 205.186 325.28 205.595 309.599C206.004 293.918 209.726 281.806 212.221 276.994H205.186C205.186 276.994 199.147 283.242 198.152 298.225C197.165 313.208 198.561 326.555 198.561 326.555C198.561 326.555 173.464 320.756 166.951 312.013",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.156 271.532H209.493L205.194 276.994L174.065 276.031",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.493 271.532C209.493 271.532 227.974 242.52 268.27 253.782M284.24 171.046C284.24 171.046 251.763 171.688 189.618 201.365",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.271 253.782L274.206 256.958H310.966L299.801 242.007L299.191 213.741L300.314 189.173L299.905 176.573L301.645 171.046H284.24",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.411 171.046L297.282 165.72",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 175.851H300.314",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.206 256.958C274.206 256.958 285.403 261.153 294.21 274.949C303.017 288.737 302.263 305.26 302.263 305.26V342.124H604.803V248.456H616V12L544.598 14.2459C544.598 14.2459 476.196 18.9541 421.317 40.1212C366.438 61.2883 343.563 94.6632 343.563 94.6632L325.62 120.138L297.5 165.5",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.408 14.4143L554.151 76.4318H368.925C368.925 76.4318 363.743 76.8088 358.449 84.5088",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.541 248.937H403.021",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.529 259.204H435.514C435.514 259.204 437.014 249.972 439.709 248.929",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.556 248.937C454.556 248.937 458.037 252.955 458.037 259.212H550.461L553.533 248.937",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.514 259.204L436.677 274.941C436.677 274.941 437.904 279.24 439.717 279.312C441.53 279.384 453.746 279.312 453.746 279.312C453.746 279.312 456.24 278.598 457.026 274.74C457.812 270.882 458.053 259.212 458.053 259.212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.722 258.153L441.385 275.149H452.101L455.237 258.153L453.056 251.6H440.832L438.722 258.153Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.237 258.153H458.037",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.723 258.153H435.514",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.5 283.274C298.5 283.274 298 283.274 307.998 283.274H430.052V259.212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.052 283.274V342.116",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.052 318.494L314.343 319.312V311.123H430.052H604.803",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.369 259.204C315.369 259.204 321.24 268.115 323.013 276.031H430.052H437.046",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.392 276.031V259.203L403.021 248.937H304.974",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.647 193.85H490.457C485.163 193.85 480.832 189.518 480.832 184.225V128.383C480.832 123.089 485.163 118.758 490.457 118.758H532.647C537.941 118.758 542.272 123.089 542.272 128.383V184.225C542.272 189.518 537.941 193.85 532.647 193.85Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.836 242.721H482.548C477.255 242.721 472.923 238.39 472.923 233.096V215.209C472.923 209.916 477.255 205.584 482.548 205.584H534.836C540.13 205.584 544.462 209.916 544.462 215.209V233.096C544.462 238.39 540.13 242.721 534.836 242.721Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.73 188.387H495.647C490.353 188.387 486.021 184.056 486.021 178.762V133.845C486.021 128.551 490.353 124.22 495.647 124.22H527.73C533.024 124.22 537.355 128.551 537.355 133.845V178.762C537.355 184.056 533.024 188.387 527.73 188.387Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.874 238.077H483.495C480.68 238.077 478.378 235.775 478.378 232.959V215.345C478.378 212.53 480.68 210.228 483.495 210.228H533.874C536.69 210.228 538.992 212.53 538.992 215.345V232.959C539 235.775 536.698 238.077 533.874 238.077Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.416 350.289C278.568 350.289 298.958 329.899 298.958 304.746C298.958 279.594 278.568 259.204 253.416 259.204C228.263 259.204 207.873 279.594 207.873 304.746C207.873 329.899 228.263 350.289 253.416 350.289Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.416 330.493C267.636 330.493 279.163 318.966 279.163 304.746C279.163 290.526 267.636 278.999 253.416 278.999C239.196 278.999 227.669 290.526 227.669 304.746C227.669 318.966 239.196 330.493 253.416 330.493Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.416 346.278C276.353 346.278 294.948 327.684 294.948 304.746C294.948 281.809 276.353 263.214 253.416 263.214C230.478 263.214 211.884 281.809 211.884 304.746C211.884 327.684 230.478 346.278 253.416 346.278Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.416 326.868C265.633 326.868 275.538 316.964 275.538 304.746C275.538 292.529 265.633 282.625 253.416 282.625C241.199 282.625 231.294 292.529 231.294 304.746C231.294 316.964 241.199 326.868 253.416 326.868Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.416 311.941C257.389 311.941 260.611 308.72 260.611 304.746C260.611 300.773 257.389 297.552 253.416 297.552C249.442 297.552 246.221 300.773 246.221 304.746C246.221 308.72 249.442 311.941 253.416 311.941Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.855 86.1289L307.1 175.85",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.174 87.1796H417.146C417.146 87.1796 424.91 85.5835 428.576 93.0028C428.576 93.0028 428.833 123.787 424.485 136.5C424.485 136.5 423.804 143.582 414.596 145.203C405.388 146.823 348.584 150.488 348.584 150.488C348.584 150.488 340.226 150.745 339.881 144.858L344.662 120.466",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.693 115.766C347.693 115.766 343.033 130.316 342.44 144.088C342.44 144.088 341.926 148.307 346.105 148.355C346.105 148.355 402.692 145.58 414.331 142.941C414.331 142.941 419.961 142.644 422.689 134.623C422.689 134.623 427.252 103.278 426.442 94.9682C426.442 94.9682 426.571 91.1342 420.146 88.6558H365.147",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.031 213.645C382.031 213.645 387.742 208.528 395.498 213.645L394.624 233.152L388.76 235.919L382.897 233.152L382.031 213.645Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.268 217.022H387.196V233.505H390.268V217.022Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.196 218.762L384.229 220.399V231.612H387.509",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.268 218.762L393.396 220.351V231.612H390.268",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.76 215.899C389.792 215.899 390.629 215.062 390.629 214.03C390.629 212.998 389.792 212.161 388.76 212.161C387.728 212.161 386.891 212.998 386.891 214.03C386.891 215.062 387.728 215.899 388.76 215.899Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.43 248.456L331.339 254.07H408.853H436.717",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.235 254.07H552.001",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.327 192.341H187.957C187.957 192.341 189.048 192.133 189.217 190.906C189.385 189.679 189.217 178.923 189.217 178.923C189.217 178.923 189.369 177.27 187.476 177.134C185.583 176.997 183.995 177.134 183.995 177.134",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.102 192.342H179.287C179.287 192.342 178.365 192.622 179.287 193.978C180.209 195.333 193.011 210.87 193.011 210.87C193.011 210.87 194.31 212.129 193.941 216.773",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.263 328.015H604.803",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.416 291.343C255.263 291.343 256.761 289.846 256.761 287.999C256.761 286.151 255.263 284.654 253.416 284.654C251.569 284.654 250.071 286.151 250.071 287.999C250.071 289.846 251.569 291.343 253.416 291.343Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.629 308.091C272.476 308.091 273.973 306.594 273.973 304.746C273.973 302.899 272.476 301.402 270.629 301.402C268.781 301.402 267.284 302.899 267.284 304.746C267.284 306.594 268.781 308.091 270.629 308.091Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.716 308.091C238.564 308.091 240.061 306.594 240.061 304.746C240.061 302.899 238.564 301.402 236.716 301.402C234.869 301.402 233.372 302.899 233.372 304.746C233.372 306.594 234.869 308.091 236.716 308.091Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.416 324.839C255.263 324.839 256.761 323.341 256.761 321.494C256.761 319.647 255.263 318.149 253.416 318.149C251.569 318.149 250.071 319.647 250.071 321.494C250.071 323.341 251.569 324.839 253.416 324.839Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.677 319.312C266.524 319.312 268.022 317.815 268.022 315.968C268.022 314.12 266.524 312.623 264.677 312.623C262.83 312.623 261.333 314.12 261.333 315.968C261.333 317.815 262.83 319.312 264.677 319.312Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.882 297.198C243.729 297.198 245.227 295.701 245.227 293.854C245.227 292.006 243.729 290.509 241.882 290.509C240.035 290.509 238.537 292.006 238.537 293.854C238.537 295.701 240.035 297.198 241.882 297.198Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.487 297.198C267.335 297.198 268.832 295.701 268.832 293.854C268.832 292.006 267.335 290.509 265.487 290.509C263.64 290.509 262.143 292.006 262.143 293.854C262.143 295.701 263.64 297.198 265.487 297.198Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.882 318.983C243.729 318.983 245.227 317.486 245.227 315.639C245.227 313.791 243.729 312.294 241.882 312.294C240.035 312.294 238.537 313.791 238.537 315.639C238.537 317.486 240.035 318.983 241.882 318.983Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.855 86.1289L370.36 80.7549L368.933 80.7629C368.933 80.7629 361.898 80.4581 358.457 84.5167L301.75 171",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.352 80.7471H422.344C426.603 80.7471 430.052 84.196 430.052 88.4551V248.937",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.344 80.7471C422.344 80.7471 432.097 81.0599 432.506 86.0168C432.915 90.9737 432.506 248.929 432.506 248.929",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.964 70.4963C374.964 70.4963 414.604 42.0623 461.999 32.2046",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.914 332.586C321.695 333.367 321.695 334.633 320.914 335.414L308.186 348.142C307.405 348.923 306.139 348.923 305.358 348.142C304.577 347.361 304.577 346.095 305.358 345.314L316.672 334L305.358 322.686C304.577 321.905 304.577 320.639 305.358 319.858C306.139 319.077 307.405 319.077 308.186 319.858L320.914 332.586ZM76.0858 335.414C75.3047 334.633 75.3047 333.367 76.0858 332.586L88.8137 319.858C89.5948 319.077 90.8611 319.077 91.6421 319.858C92.4232 320.639 92.4232 321.905 91.6421 322.686L80.3284 334L91.6421 345.314C92.4232 346.095 92.4232 347.361 91.6421 348.142C90.8611 348.923 89.5948 348.923 88.8137 348.142L76.0858 335.414ZM319.5 336L77.5 336L77.5 332L319.5 332L319.5 336Z",
    fill: "#2D9DC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.024 128.109L339.277 128.125C340.075 128.126 340.551 129.015 340.108 129.679L331.53 142.554C331.345 142.833 331.033 143 330.698 143L315.034 143C314.251 143 313.771 142.139 314.184 141.473L322.173 128.582C322.356 128.288 322.678 128.108 323.024 128.109Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_282_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.593 138.298H324.648C324.412 138.298 324.12 138.46 323.995 138.66L322.146 141.619C322.021 141.819 322.111 141.981 322.347 141.981H323.292C323.527 141.981 323.82 141.819 323.945 141.619L325.794 138.66C325.919 138.46 325.829 138.298 325.593 138.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.403 129H330.458C330.222 129 329.929 129.162 329.804 129.362L327.956 132.321C327.831 132.521 327.92 132.683 328.156 132.683H329.101C329.337 132.683 329.63 132.521 329.755 132.321L331.604 129.362C331.729 129.162 331.639 129 331.403 129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.615 134.728H320.126C319.89 134.728 319.597 134.89 319.472 135.09L318.971 135.891C318.846 136.091 318.936 136.253 319.172 136.253H322.661C322.897 136.253 323.19 136.091 323.315 135.891L323.815 135.09C323.94 134.89 323.85 134.728 323.615 134.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.578 134.728H331.089C330.853 134.728 330.56 134.89 330.435 135.09L329.935 135.891C329.81 136.091 329.899 136.253 330.135 136.253H333.624C333.86 136.253 334.153 136.091 334.278 135.891L334.778 135.09C334.903 134.89 334.814 134.728 334.578 134.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.438 139.796L318.752 140.363C318.831 140.504 319.101 140.504 319.356 140.363L323.13 138.271C323.385 138.13 323.529 137.9 323.45 137.759L323.136 137.192C323.058 137.051 322.787 137.051 322.532 137.192L318.758 139.284C318.503 139.425 318.36 139.655 318.438 139.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.393 130.618L330.618 132.71C330.363 132.851 330.22 133.081 330.298 133.222L330.612 133.789C330.691 133.93 330.961 133.93 331.216 133.789L334.991 131.697C335.246 131.555 335.389 131.326 335.311 131.184L334.997 130.618C334.918 130.476 334.648 130.476 334.393 130.618Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324 143.5L324 350",
    stroke: "#2D9DC9",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -16,
    y1: 349.5,
    x2: 500,
    y2: 349.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 318.5,
    width: 30,
    height: 31,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 350,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_282_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.3293,
    height: 15.3293,
    fill: "white",
    transform: "matrix(1 0 -0.529919 0.848048 323.277 129)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/object.20f0763c91727bdc143839c7598b175a.svg";
export { ForwardRef as ReactComponent };